import apiClient from "./client";

/** Latest published version row + measured server schema (shown on About). */
export function getLatestVersion() {
  return apiClient.get("/software-version/latest").then((r) => r.data);
}

/** Admin: full version history (newest first). */
export function getAllVersions() {
  return apiClient.get("/software-version/all").then((r) => r.data);
}

/** Admin: create a new published version row. */
export function createVersion(payload) {
  return apiClient.post("/software-version", payload).then((r) => r.data);
}

/** Admin: update an existing version row. */
export function updateVersion(id, payload) {
  return apiClient.put(`/software-version/${id}`, payload).then((r) => r.data);
}

/** Admin: delete a version row. */
export function deleteVersion(id) {
  return apiClient.delete(`/software-version/${id}`);
}
